function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlower11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4409",
    viewBox: "0 0 79.374996 79.375002",
    height: 300,
    width: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-217.62499)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2033",
    style: {
      fill: "#442db9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 48.430524,229.22463 c 0,4.80836 -8.706553,25.9468 -8.706553,25.9468 0,0 -8.706205,-21.13844 -8.706205,-25.9468 0,-4.80836 3.897842,-8.70691 8.706205,-8.70691 4.808712,0 8.706553,3.89855 8.706553,8.70691"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2035",
    style: {
      fill: "#442db9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 24.987384,228.1222 c 3.872089,3.87173 14.736587,27.04923 14.736587,27.04923 0,0 -23.177148,-10.86449 -27.049237,-14.73623 -3.8717362,-3.87209 -4.2555582,-9.76701 -0.854428,-13.16708 3.399367,-3.40077 9.295342,-3.01766 13.167078,0.85408"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2037",
    style: {
      fill: "#442db9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 11.215998,246.46523 c 5.2832,0 28.507973,8.7062 28.507973,8.7062 0,0 -23.224773,8.70691 -28.507973,8.70691 -5.2828472,0 -9.5655692,-3.89819 -9.5655692,-8.70691 0,-4.80871 4.282722,-8.70585 9.5655692,-8.7062"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2039",
    style: {
      fill: "#442db9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 13.045151,269.5376 c 3.80365,-3.80294 26.67882,-14.36617 26.67882,-14.36617 0,0 -10.562522,22.87588 -14.365818,26.67882 -3.802944,3.8033 -9.642827,4.13068 -13.043252,0.73096 -3.3997192,-3.40043 -3.0723422,-9.24031 0.73025,-13.04361"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2041",
    style: {
      fill: "#442db9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 31.017766,285.2662 c 0,-5.57707 8.706205,-30.09477 8.706205,-30.09477 0,0 8.706553,24.5177 8.706553,30.09477 0,5.57706 -3.897841,10.09862 -8.706553,10.09862 -4.808363,0 -8.706205,-4.52156 -8.706205,-10.09862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2043",
    style: {
      fill: "#442db9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 54.544871,282.30533 c -3.887259,-3.88655 -14.8209,-27.1339 -14.8209,-27.1339 0,0 23.246289,10.934 27.134253,14.8209 3.887611,3.88797 4.282369,9.79594 0.88265,13.19601 -3.400073,3.40007 -9.307689,3.00461 -13.196003,-0.88301"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2045",
    style: {
      fill: "#442db9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 68.004751,263.87834 c -5.239808,2.7e-4 -28.28078,-8.70691 -28.28078,-8.70691 0,0 23.040972,-8.70585 28.28078,-8.7062 5.241573,3.4e-4 9.490786,3.89749 9.490786,8.7062 0,4.80872 -4.249213,8.70691 -9.490786,8.70691"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2047",
    style: {
      fill: "#442db9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 65.090456,242.1183 c -3.560233,3.55988 -25.366485,13.05313 -25.366485,13.05313 0,0 9.493602,-21.8059 13.052777,-25.36542 3.560937,-3.55988 9.20256,-3.69006 12.602278,-0.28928 3.401132,3.39972 3.271309,9.04205 -0.28857,12.60157"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2049",
    style: {
      fill: "#e1e644",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 46.143114,255.30549 c 0,3.54471 -2.874081,6.41844 -6.419143,6.41844 -3.544713,0 -6.418088,-2.87373 -6.418088,-6.41844 0,-3.54507 2.873375,-6.41879 6.418088,-6.41879 3.545062,0 6.419143,2.87372 6.419143,6.41879"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower11);
export default __webpack_public_path__ + "static/media/flower-11.18fe9df6490306c332104e36db8ddb6e.svg";
export { ForwardRef as ReactComponent };